/**
 * Alle tekst die een GAST te zien krijgt, in het Nederlands.
 *
 * Dit bestand is de BRON. De andere talen worden hieruit gemaakt met
 * scripts/vertaal-teksten.ts en daarna vastgelegd - niet bij het opstarten
 * vertaald, want dan betaal je elke keer opnieuw voor hetzelfde en werkt de
 * app niet zonder verbinding.
 *
 * Voeg je hier een sleutel toe, dan meldt de typecheck dat hij in de andere
 * talen ontbreekt. Draai daarna het vertaalscript.
 *
 * WAT HIER NIET IN STAAT: het scherm om een kamer aan te maken. Dat gebruikt
 * alleen de beheerder, en die spreekt Nederlands. Vertalen wat niemand leest,
 * kost onderhoud zonder opbrengst.
 */
export const nl = {
  // --- voorportaal ---
  kamerOphalen: 'Kamer ophalen…',
  kamerWerktNiet: 'Deze kamer werkt niet',
  serverReageertNiet: 'De server reageert niet',
  probeerOpnieuw: 'Probeer opnieuw',
  vraagNieuweCode: 'Vraag degene die de code deelde om een nieuwe. Een kamer verloopt na een paar uur.',
  welkeTaalSprekJij: 'Welke taal spreek jij?',
  jouwStem: 'Jouw stem in de vertaling',
  man: 'Man',
  vrouw: 'Vrouw',
  pincode: 'Pincode',
  pincodeUitleg: 'Die krijg je van degene die de code deelde.',
  gaDeKamerIn: 'Ga de kamer in',
  kiesEerstJeTaal: 'Kies eerst je taal',
  microfoonAanvragen: 'Microfoon aanvragen…',
  toestemmingUitleg:
    'Je browser vraagt zo om toestemming voor de microfoon. Zonder dat kun je alleen typen.',
  microfoonTestLink: 'Eerst je microfoon testen',
  stemGaatMee: 'In deze kamer hoort de ander ook je eigen stem, naast de vertaling.',
  alleenChatMelding:
    'Dit gesprek is alleen chat. Je typt je berichten en leest de vertaling; er wordt niets voorgelezen.',
  verlooptOm: 'Verloopt om',
  nooitVasteKamer: 'Nooit, vaste kamer',
  kamer: 'Kamer',
  tolkgesprek: 'Tolkgesprek',
  juisteKamer: 'Je bent bij de juiste kamer. Zo meteen kun je hier meepraten.',

  // --- in de kamer ---
  jij: 'jij',
  deAnder: 'de ander',
  verbinden: 'Verbinden…',
  verbonden: 'Verbonden',
  verbindingKwijt: 'Verbinding kwijt. Opnieuw proberen…',
  wachtenOpAnder: 'Je bent binnen. Wachten tot de ander de QR-code scant.',
  allebeiInDeKamer: 'Jullie zitten allebei in de kamer.',
  anderIsWeg: 'De ander is weg',
  anderSpreekt: 'De ander spreekt…',
  jeKuntErNietIn: 'Je kunt er niet in',
  overgenomenTitel: 'Verdergegaan op een ander apparaat',
  overgenomenUitleg:
    'Dit gesprek is zojuist op een ander apparaat geopend. Daar praat je verder.',
  terug: 'Terug',
  geluidStaatUit: 'Het geluid staat uit. Tik ergens op het scherm.',
  tikHier: 'tik hier',
  /**
   * Wat er met je gesprek gebeurt, in EEN regel.
   *
   * Tot 7 september 2026 werd een gesprek nergens bewaard en verdween het bij
   * een gesloten tabblad of een herstart - zonder dat iemand dat te horen
   * kreeg. Nu blijft het staan tot de kamer verloopt, en dat hoor je te weten:
   * er staat tekst van je op de server, en op een dag staat hij er niet meer.
   *
   * {tijd} wordt vervangen door het tijdstip, in de notatie van JOUW taal.
   */
  bewaardTot: 'Bewaard tot {tijd}',
  bewaardVast: 'Vaste kamer. Berichten blijven 30 dagen bewaard.',

  // --- praten ---
  spreekIn: 'Spreek in',
  luisteren: 'Luisteren… tik om te stoppen',
  uitschrijven: 'Uitschrijven…',
  tijdOmTeVerbeteren: 'Tijd om te verbeteren',
  altijdZelfVersturen: 'Altijd zelf nakijken en versturen',
  jijVerstuurtZelf: 'Jij verstuurt zelf',
  uit: 'uit',
  sec: 'sec',
  vertalingMeteenAfspelen: 'Vertaling meteen afspelen',
  typHierJeBericht: 'Typ hier je bericht…',
  stuur: 'Stuur',
  geenOpnameMogelijk: 'Deze browser kan geen audio opnemen. Typen werkt wel.',

  // --- bevestigen ---
  verstaanAls: 'Verstaan als',
  tellerStaatStil: 'teller staat stil',
  versturen: 'Versturen',
  wis: 'Wis',

  // --- bericht ---
  jijZei: 'jij zei',
  vertaald: 'vertaald',

  // --- duimpjes ---
  duimOmhoog: 'Dit klopt',
  duimOmlaag: 'Dit klopt niet',
  opnieuwProberenKnop: 'Opnieuw proberen met een beter model',
  opnieuwProberenBezig: 'Opnieuw aan het vertalen…',
  duimTranscriptWoordenlijstUitnodiging: 'Verkeerd verstaan? Zet het recht in de woordenlijst:',

  // --- instellingen tijdens het gesprek ---
  instellingenAanpassen: 'Instellingen aanpassen',
  geldtVoorJullieBeiden: 'Geldt voor jullie allebei',
  alleenVoorJou: 'Alleen voor jou',
  stuurMijnStemMee: 'Stuur mijn eigen stem mee',
  verbeterSpelfouten: 'Verbeter spelfouten in mijn tekst',
  verbeterSpelfoutenUit:
    'Uit zetten laat zien wat er werkelijk verstaan werd, fouten en al.',
  alleenChat: 'Alleen chat: geen spraak, geen microfoon',
  alleenChatUitleg:
    'Jullie typen allebei. De vertaling en de originele tekst staan in beeld; er wordt niets voorgelezen.',
  aangepastDoorDeAnder: 'De ander paste de instellingen aan.',
  foutSpraak: 'De vertaling is er wel, maar er kwam geen stem uit.',
  foutSpraakQuota:
    'Het spraaktegoed voor vandaag is op. De tekst werkt gewoon door; stem komt morgen terug.',
  foutBudgetKamer:
    'De limiet van dit gesprek is bereikt, dus er wordt even niet vertaald. De maker van het gesprek kan hem verhogen; daarna werkt het meteen weer.',
  foutBudgetMaand:
    'Het maandbudget van de app is op. Vertalen lukt pas weer als de beheerder het aanpast.',
  foutTaal: 'Die taal kan niet: jullie zouden allebei dezelfde spreken.',
  origineel: 'origineel',
  vertalen: 'Vertalen…',
  vertalenMislukt: 'Vertalen lukte niet.',
  opnieuwAfspelen: 'Vertaling opnieuw afspelen',
  hoorDeAnder: 'Luister hoe de ander het zelf zei',

  // --- woordenlijst ---
  woordenlijst: 'Vangnet-woordenlijst',
  woordenlijstUitleg:
    'Verstaat de app een naam of vakterm structureel verkeerd? Leg hier vast wat er bedoeld wordt.',
  hijHoort: 'hij hoort…',
  jijBedoelt: 'jij bedoelt…',
  ookVolgendeGesprekken: 'Ook in volgende gesprekken — anders geldt hij alleen hier',
  voegToe: 'Voeg toe',
  bezig: 'Bezig…',
  lijstNietGeladen: 'De lijst kon niet geladen worden.',
  toevoegenMislukt: 'Toevoegen lukte niet.',
  verwijderenMislukt: 'Verwijderen lukte niet.',
  overal: 'overal',
  verwijder: 'Verwijder',

  // --- instellingen ---
  overDitGesprek: 'Over dit gesprek',
  toon: 'Toon van de vertaling',
  sfeer: 'Sfeer van het gesprek',
  jouwPlek: 'Jouw plek',
  hoeHetWerkt:
    'De server schrijft je opname uit en vertaalt hem in één keer. Je eigen stem gaat mee naar de ander.',
  kleinereTekst: 'Kleinere tekst',
  grotereTekst: 'Grotere tekst',
  insprekenVerbergen: 'Inspreken verbergen',
  insprekenTonen: 'Inspreken tonen',
  toetsenbordVerbergen: 'Toetsenbord verbergen',
  toetsenbordTonen: 'Toetsenbord tonen',

  // --- toon van de vertaling ---
  vormAutomatisch: 'Automatisch',
  vormInformeel: 'Je en jij',
  vormFormeel: 'U',
  sfeerNeutraal: 'Neutraal',
  sfeerZakelijk: 'Zakelijk',
  sfeerOfficieel: 'Officieel',
  sfeerVriendschappelijk: 'Vriendschappelijk',
  sfeerPartner: 'Partner',

  // --- foutmeldingen ---
  foutKamerVol: 'Deze kamer zit vol. Er kunnen maar twee mensen in.',
  /**
   * Bezet door wie dezelfde taal koos. Meestal jijzelf op een ander apparaat.
   * WISSEL is in ELKE taal hetzelfde woord: dat is wat je intypt, en de
   * client controleert precies dat woord.
   */
  plekBezetTitel: 'Jouw plek is bezet',
  plekBezetUitleg:
    'Iemand zit al aan jouw kant van dit gesprek, in jouw taal. Meestal ben je dat zelf: het gesprek staat nog open op een ander apparaat of in een ander tabblad. Sluit het daar en probeer het opnieuw. Soms duurt het anderhalve minuut voor de plek vrij is.',
  plekBezetWissel:
    'Ben je het zelf? Typ WISSEL om het gesprek naar dit apparaat te halen. Het andere apparaat gaat dan dicht.',
  plekBezetKnop: 'Naar dit apparaat halen',
  foutKamerVerlopen: 'Deze kamer is verlopen of gesloten.',
  foutKamerOnbekend: 'Deze kamer bestaat niet.',
  foutPinNodig: 'Deze kamer heeft een pincode nodig.',
  foutPinFout: 'Die pincode klopt niet.',
  foutProtocol: 'De app en de server begrijpen elkaar niet. Ververs de pagina.',
  foutMicroGeweigerd:
    'Je hebt de microfoon geweigerd. Klik op het slotje in de adresbalk en zet hem alsnog aan.',
  foutGeenMicro: 'Er is geen microfoon gevonden. Sluit er een aan en probeer het opnieuw.',
  foutMicroInGebruik:
    'De microfoon is in gebruik door een ander programma. Sluit dat en probeer opnieuw.',
  foutGeenHttps:
    'De microfoon werkt alleen op een beveiligde verbinding. Open deze pagina via https.',
  foutMicroOnbekend: 'De microfoon kon niet gestart worden.',
  foutNietsOpgenomen: 'Er is niets opgenomen. Staat je microfoon aan?',
  foutNietsGehoord: 'Niets gehoord. Staat je microfoon aan en spreek je hard genoeg?',
  foutOpnameTeLang: 'Die opname is te lang. Spreek in kortere stukken.',
  foutMicroGedempt: 'Je microfoon staat gedempt. Zet hem aan en probeer opnieuw.',

  // --- microfoontest ---
  micTitel: 'Microfoontest',
  micOnderschrift: 'Vier tests na elkaar, elk vijf seconden. Blijf de hele tijd praten.',
  micStart: 'Start de test',
  micTest1: '1. Alleen herkennen',
  micTest2: '2. Alleen opnemen',
  micTest3: '3. Samen — opname eerst',
  micTest4: '4. Samen — herkenning eerst',
  micFase1: '1 van 4: alleen herkennen — zeg een korte zin',
  micFase2: '2 van 4: alleen opnemen — praat door',
  micFase3: '3 van 4: opname eerst, dan herkenning — praat door',
  micFase4: '4 van 4: herkenning eerst, dan opname — praat door',
  micKlaar: 'klaar',
  micGehoord: 'gehoord',
  micOpnameformaat: 'Opnameformaat',
  micGeen: 'geen',
  micBeveiligd: 'Beveiligde verbinding',
  micJa: 'ja',
  micNee: 'NEE',
  micBrowser: 'Browser',
  micGeenHttps: 'Zonder https geeft de browser geen microfoon vrij. Op localhost mag het wel.',
  micGeenHerkenning: 'Deze browser kent geen spraakherkenning.',
  micZegIets: 'zeg iets…',
  micWoordenBinnen: 'woorden komen binnen',
  micKonNietStarten: 'kon niet starten',
  micGeenRecorder: 'Deze browser kent MediaRecorder niet.',
  micOpnemen: 'opnemen…',
  micNietsOpgenomen: 'niets opgenomen',
  micGeenMicrofoon: 'geen microfoon',
  micOpnameEerst: 'opname eerst…',
  micHerkenningEerst: 'herkenning eerst…',
  micOpnameStarttNiet: 'opname startte niet',
  micSamenGelukt: 'Samen. Opname {kb} kB.',
  micAlleenOpname: 'Opname wel, herkenning niet.',
  micAlleenHerkenning: 'Herkenning wel, opname niet.',
  micGeenVanBeide: 'Geen van beide.',
  micNetwerkFout: 'De spraakherkenning kon de server niet bereiken.',
  micAfgebroken: 'De opname is afgebroken.',
  // --- gespreksverslag (PDF) ---
  //
  // Het verslag staat in DE TWEE TALEN VAN HET GESPREK, niet alleen in die
  // van de lezer: de beheerder downloadt het en geeft het aan de ander.
  // {x} is A of B, {tijd} het moment van wissen in de notatie van de taal.
  // Bij talen die hun woorden verbuigen staat {tijd} achter een dubbele
  // punt, zodat een datum nooit in de verkeerde naamval hoeft.
  verslagTitel: 'Gespreksverslag',
  verslagWie: 'Wie',
  verslagOrigineel: 'Origineel',
  verslagVertaling: 'Vertaling',
  verslagSpreker: 'Spreker {x}',
  verslagBerichten: 'Berichten',
  verslagGemaaktOp: 'Gemaakt op',
  verslagGeenOpname: 'Geen letterlijke opname.',
  verslagNootOrigineel: '„Origineel” is de tekst zoals de app de spreker verstond.',
  verslagNootCorrectie: 'De spellingcorrectie stond aan: kleine schrijffouten zijn verbeterd.',
  verslagNootAangepast: 'Wie insprak, kon de tekst vóór het versturen nog aanpassen.',
  verslagGesproken: 'gesproken',
  verslagGetypt: 'getypt',
  verslagMislukt: 'Vertaling mislukt. De ander heeft deze zin niet in de eigen taal gezien.',
  verslagNietKlaar: 'De vertaling was nog niet klaar toen dit verslag werd gemaakt.',
  verslagVertrouwelijk: 'Vertrouwelijk.',
  verslagAlleenDeelnemers: 'Dit verslag bevat de inhoud van een privégesprek en is alleen bedoeld voor de deelnemers.',
  verslagGewist: 'Het gesprek wordt gewist vanaf {tijd}. Daarna kan dit verslag niet opnieuw gemaakt worden.',
  verslagGewistVast:
    'Vaste kamer: elk bericht wordt 30 dagen na het versturen gewist. Oudere berichten staan niet in dit verslag.',
} as const;

/**
 * De SLEUTELS liggen vast, de TEKSTEN niet.
 *
 * Met `typeof nl` zou elke vertaling exact de Nederlandse zin moeten zijn -
 * dat gaf 88 typefouten per taal. Deze vorm eist wel dat elke taal ALLE
 * sleutels heeft: vergeet je er een, dan meldt de typecheck dat.
 */
export type Teksten = { readonly [K in keyof typeof nl]: string };
export type TekstSleutel = keyof Teksten;
